var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlasses = function SvgGlasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 49,
    height: 36,
    viewBox: "0 0 3.37 2.47",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.34;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}.fil1{fill:#000}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1.42.19C2.21.04 2.75.7 2.47 1.41c-.14.34-.41.73-.69.87-.28.14-.96-.59-1.02-1.12C.71.65.9.29 1.42.19z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2312403310624"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M.62 1.11c-.12.61.84.89.83.01 0-.4-.75-.43-.83-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1.51 1.25c.02 0 .24.02.31.01M2.65 1.18c.18-.24.36-.41.54-.65M.72 1.12C.71 1.09.27.71.2.64L.17.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1.87 1.11c-.12.61.84.89.83.01 0-.4-.75-.43-.83-.01z"
  })))));
};

export default SvgGlasses;